import moment from 'moment';
import { BaseGraphTransformer } from './BaseGraphTransformer';

// eslint-disable-next-line max-len
export class LiftOneRepMaxHistoryGraphTransformer extends BaseGraphTransformer {
    constructor(params) {
        super(params);
    }

    getProps() {
        this.graphProps.chartType = 'line';
        return this.graphProps;
    }

    transformData(data) {
        const xValues = [];
        const yValues = [];

        for (let i = 0; i < data.length; i++) {
            const formattedDate = moment(data[i].date_completed).format(
                'YYYY-MM-DD'
            );
            const estimated1RM = data[i].estimated_one_rep_max;
            xValues.push(formattedDate);
            yValues.push(estimated1RM);
        }

        return {
            graphProps: this.getProps(),
            xValues: ['xValues', ...xValues],
            yValues: ['Estimated 1 RM', ...yValues]
        };
    }
}



// WEBPACK FOOTER //
// ./src/lib/transformer/LiftOneRepMaxHistoryGraphTransformer.js